// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"241a2404","374":"962474c0","500":"0f093fd8","521":"615aecb7"}[chunkId] + ".css";
};